import { useIntersectionObserver } from "@vueuse/core";
import type { MaybeElementRef } from "@vueuse/core";

export default function useFormIntersection(element?: MaybeElementRef) {
  const formAboveView = useState(() => false);

  if (element) {
    useIntersectionObserver(element, setIsAboveView);
  }

  return {
    formAboveView
  };

  function setIsAboveView([entry]: IntersectionObserverEntry[]) {
    formAboveView.value = !entry.isIntersecting && entry.boundingClientRect.top < 0;
  }
}